import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const InvoiceItemDetails = () => {
  const { invoiceItemId } = useParams();
  const decodedId = invoiceItemId ? atob(invoiceItemId) : invoiceItemId;
  const id = decodedId.replace(/\D/g, ''); 
  const [invoiceItemDetails, setInvoiceItemDetails] = useState(null);
  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {
    fetchInvoiceItemDetails();
  }, [invoiceItemId]);

  const fetchInvoiceItemDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.invoice_item}${id}/`, { headers });
      const extractedColumns = Object.keys(response.data);
      const excludedColumns = ['id', 'created_at', 'updated_at', 'invoice'];
      const columnsArray = extractedColumns
        .filter((column) => !excludedColumns.includes(column))
        .map((column) => ({
          label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
          field: column,
        }));

      if (response.data.invoice) {
        const invoiceResponse = await axios.get(`${API_DOMAIN}${API_ROUTES.invoice}${response.data.invoice}/`, { headers });
        if (invoiceResponse) {
          response.data.invoice_number = invoiceResponse.data.invoice_number;
          extractedColumns.push('invoice_number');
          columnsArray.push({
            label: 'Invoice Number',
            field: 'invoice_number',
          });
        }
      }

      setColumnDetails(columnsArray);
      setInvoiceItemDetails(response.data);
    } catch (error) {
      console.error('Error fetching invoice item details:', error);
    }
  };

  return (
    <div>
      {invoiceItemDetails ? (
        <div>
          <SingleItemDetailTemplate details={invoiceItemDetails} columns={columns} />
        </div>
      ) : (
        <p>Loading invoice item details...</p>
      )}
    </div>
  );
};

export default InvoiceItemDetails;